import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class PlsSvdGraph extends AbstractScatterVisualization {
}
